module.exports = __webpack_public_path__ + "img/block-purple.aceb947e.webp";